/**
 * 全局变量 和 设置 、配置等。。。
 */
import axios from "axios"; // 引入axios
import store from "@/store"; // 引入vuex
import router from "@/router";
import { Message } from "element-ui";
import { banList } from './public'

// 创建axios实例
const instance = axios.create({
  baseURL: store.state.host,
  //设置5分钟请求超时
  timeout: 1000 * 5 * 60,
});
// 防止在ie浏览器请求不了
instance.defaults.headers.post["Content-Type"] =
  "application/json;charset=utf-8";

//token快要过期的时候刷新(如果已经过期了，直接返回登录页面)
let refresh_token = async function() {
  let url = store.state.host + "admin/authorizations/update";
  await instance
    .post(url)
    .then((response) => {
      if (response.data.status === 1) {
        //刷新令牌成功后session存储
        sessionStorage.setItem("access_token", response.data.data.access_token);
        sessionStorage.setItem(
          "access_token_expired_at",
          response.data.data.expired_at
        );
        store.commit('updateLogin', response.data.data)
      } else {
        //刷新令牌失败后，重新登录
        sessionStorage.removeItem('access_token')
        sessionStorage.removeItem('access_token_expired_at')
        router.replace({path: '/',})
      }
    })
    .catch((error) => {
      // console.log(error)
      //重新登录
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("access_token_expired_at");
      router.replace({ path: "/" });
    })
    .finally(() => {});
};

/* 请求拦截器 */
instance.interceptors.request.use(
  async (config) => {
    //先判断是不是登录页面,因为一开始登录的时候，是不会有token exp
    if (
      sessionStorage.getItem("access_token") &&
      sessionStorage.getItem("access_token_expired_at")
    ) {
      let isexp =
        Number(sessionStorage.getItem("access_token_expired_at") * 1000) -
        Number(new Date());
      if (isexp < 3600000) {
        //准备过时了前1小时
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("access_token_expired_at");
        await refresh_token();
      }
    }
    if (sessionStorage.getItem("access_token")) {
      config.headers.Authorization =
        "Bearer " + sessionStorage.getItem("access_token");
    }
    //获取超级授权
    if (
      localStorage.getItem("super_token") &&
      localStorage.getItem("super_token_expired_at")
    ) {
      let isexpSuper =
        Number(localStorage.getItem("super_token_expired_at") * 1000) -
        Number(new Date());
      if (isexpSuper <= 0) {
        //过期移除
        localStorage.removeItem("super_token");
        localStorage.removeItem("super_token_expired_at");
      } else {
        config.headers.SuperToken = localStorage.getItem("super_token")
      }
    }
    if (sessionStorage.getItem("access_token")) {
      config.headers.Authorization =
        "Bearer " + sessionStorage.getItem("access_token");
    }
    config.baseURL = store.state.host
    if (config.params && (config.params.per_page || config.params.limit)) {
      if (banList(config.params)) throw new Error('权限')
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

/* 响应拦截器 */
instance.interceptors.response.use(
  (response) => {
    // console.log('response', JSON.stringify(response))
    if (response.data.status == 0) {
      switch (response.data.status_code) {
        case 403:
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("access_token_expired_at");
          Message.error("请重新登录")
          store.commit('toggleLogin')
          return;
        // token已经过期了/登录失败
        case 401:
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("access_token_expired_at");
          Message.error("请重新登录")
          store.commit('toggleLogin')
          return;
      }
      //统一处理请求错误提示
      // Message.error(response.data.message)
    }
    if (response?.config?.url === '/admin/games/select') {
      response.data.data = response.data.data.map(item => {
        return {
          ...item,
          name: item.name + (item.remark ? `(${item.remark})` : '')
        }
      })
    }
    return Promise.resolve(response); //return response
  },
  (error) => {
    if (String(error).indexOf(error.config.timeout) != -1) {
      // 请求超时处理
      Message.error("请求超时");
    }
    return Promise.reject(error);
  }
);

export default instance;
